import React from 'react'
import PropTypes from 'prop-types';
import './NotificationBadge.css'
import Icon, { IconList } from 'components/Icon';

const propTypes = {
	items: PropTypes.array,
	onClose: PropTypes.func
};
const defaultProps = {
	items: [],
	onClose: () => { }
};

function NotificationBadge({ items, onClose }) {
	return (
		<div className='notifications-container'>
			<div className='notification-item-close-button' onClick={onClose} onTouchStart={onClose}>
				<Icon icon={IconList.iconClose} containerStyle='icon_container' />
				<p className='close_btn-text'>閉じる</p>
			</div>
			<div className='notification-content'>
				{items.map((item, index) => {
					return (
						<div key={index} className='notification-item'>
							<div className='notification-item-content'>
								{item.content}
							</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}

NotificationBadge.propTypes = propTypes;
NotificationBadge.defaultProps = defaultProps;
export default NotificationBadge;